import { useState, useEffect, useRef } from "react";

type TOptions = {
  root?: any;
  rootMargin?: string;
  threshold?: number;
};

const useOnScreenHook = (options: TOptions) => {
  const defaultOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5,
    ...options,
  };

  const containerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  const callbackFunction = (entries) => {
    const [entry] = entries;
    setIsVisible(entry.isIntersecting);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callbackFunction, defaultOptions);
    if (containerRef.current) observer.observe(containerRef.current);

    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, [containerRef, options]);

  return [containerRef, isVisible];
};

export default useOnScreenHook;
